import React from 'react'
import Button from '../../../common/Button'
import Tooltip, { WithTooltip } from '../../../common/Tooltip'
import Text from 'common/components/Text'
import { withTranslation } from 'react-i18next'

export const SourceButton = ({ source, placement = 'right', t }) => {
  return (
    <WithTooltip
      placement={placement}
      tooltip={({ ref, show, hide, ...popperProps }) => (
        <Tooltip
          white
          multiline
          onMouseEnter={() => show(0)}
          onMouseLeave={() => hide(0)}
          innerRef={ref}
          {...popperProps}
        >
          <Text grey small bold>
            <a href={source} target="_blank" rel="noopener noreferrer">
              {source}
            </a>
          </Text>
        </Tooltip>
      )}
    >
      {({ ref, show, hide }) => (
        <Button
          href={source}
          target="_blank"
          innerRef={ref}
          onMouseEnter={() => show(0)}
          onMouseLeave={() => hide(0)}
          style={{ cursor: 'alias' }}
        >
          {t('blockOptions.source')}
        </Button>
      )}
    </WithTooltip>
  )
}

export default withTranslation()(SourceButton)
